<script setup lang="ts">
import { MoreHorizontal } from "@lucide/vue";
import { useI18n } from "vue-i18n";

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shared/ui";

/**
 * Меню управління послугою у detail sheet (spec §7.3, 168-T5).
 * Три дії: Перейменувати · Перемістити в категорію · Видалити.
 */
defineProps<{
  "aria-label"?: string;
}>();

const emit = defineEmits<{
  rename: [];
  move: [];
  delete: [];
}>();

const { t } = useI18n();
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button
        variant="ghost"
        size="icon"
        :aria-label="$props['aria-label'] ?? t('services.detail.manageMenuLabel')"
        data-testid="manage-menu-trigger"
      >
        <MoreHorizontal class="size-4" aria-hidden="true" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuItem
        class="min-h-11"
        data-testid="manage-rename"
        @click="emit('rename')"
      >
        {{ t("services.actions.rename") }}
      </DropdownMenuItem>
      <DropdownMenuItem
        class="min-h-11"
        data-testid="manage-move"
        @click="emit('move')"
      >
        {{ t("services.actions.moveToCategory") }}
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem
        class="min-h-11 text-destructive focus:text-destructive"
        data-testid="manage-delete"
        @click="emit('delete')"
      >
        {{ t("services.actions.delete") }}
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
